import { render, staticRenderFns } from "./card5.vue?vue&type=template&id=4d67c16c&scoped=true&"
import script from "./card5.vue?vue&type=script&lang=js&"
export * from "./card5.vue?vue&type=script&lang=js&"
import style0 from "./card5.vue?vue&type=style&index=0&id=4d67c16c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d67c16c",
  null
  
)

export default component.exports